import { Link as RouterLink, useLocation } from 'react-router-dom'
import { AppBar, Avatar, Box, Grid, Hidden, IconButton, Link, Menu, MenuItem, Toolbar, Tooltip, Typography } from '@mui/material'
import { Tabs, Tab } from '@mui/material'
import { usePopupState, bindTrigger, bindMenu } from 'material-ui-popup-state/hooks'

import MenuIcon from '@mui/icons-material/Menu'
import HelpIcon from '@mui/icons-material/Help'
import NotificationsIcon from '@mui/icons-material/Notifications'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'

import { useAuth } from '../components/AuthContext'
import NavigationCategories from '../common/NavigationCategories'

const Styles = {
    primaryBar: {
        zIndex: 0,
    },
    secondaryBar: {
        zIndex: 0,
    },
    menuButton: {
      marginLeft: -1,
    },
    iconButtonAvatar: {
      lg: {
        padding: 2,
        paddingRight: 1,
        paddingLeft: 1
      },
      md: {
        padding: 2,
        paddingRight: 1,
        paddingLeft: 1
      },
      sm: {
          padding: 2,
          paddingRight: 1,
          paddingLeft: 1
      },
      xs: {
          padding: 1,
          paddingRight: 0,
          paddingLeft: 0
      },
    },
    link: {
      textDecoration: 'none',
      color: 'lightColor',
      '&:hover': {
        color: 'white',
      },
    },
    menulink: {
      textDecoration: 'none',
      color: 'inherited',
      '&:hover': {
        textDecoration: 'none',
      },
    },
    button: {
      borderColor: 'lightColor',
    },
};

const ThoughtTypes = ['personal', 'professional', 'social'];

function Header({onDrawerToggle} : any) {
    const popupState = usePopupState({variant:'popover', popupId:'account-menu'});
    const { userInfo, refreshToken, onLogout, setTopType } = useAuth()!;

    const location = useLocation();
    let currentPage = '';
    let activeView : {title:string, subtext: string} = null!;

    const handleTabChange = ( evt: any, newValue: number ) => {
        setTopType(ThoughtTypes[newValue]);
    };

    const currentTab = (userInfo?.top_type) ? ThoughtTypes.findIndex((type) => (type === userInfo?.top_type)) : 0 ;

    NavigationCategories.forEach((parentCategory: any) => {
        parentCategory.children.forEach((category: any) => {
            if (location.pathname.startsWith(category.path)) {
                currentPage = category.path;
                activeView = category.view;
            }
        });
    });

    return (
        <Box>
            <AppBar sx={Styles.primaryBar} color='primary' position='sticky' elevation={0} >
                <Toolbar>
                    <Grid container spacing={{xs: '6px'}} alignItems='center'>
                        <Hidden smUp>
                            <Grid item>
                                <IconButton color="inherit" aria-label="open drawer" onClick={ onDrawerToggle } sx={Styles.menuButton}>
                                    <MenuIcon />
                                </IconButton>
                            </Grid>
                        </Hidden>
                        <Grid item>
                            <Typography color={'rgba(255, 255, 255, 0.7)'} > { (userInfo) ? `${userInfo.name}` : 'Not Logged In' } </Typography>
                        </Grid>
                        <Grid item xs />
                        <Grid item>
                            <Tooltip title='Alerts * No Alerts'>
                                <IconButton sx={{color: 'rgba(255, 255, 255, 0.7)'}} component={RouterLink} to='/' >
                                    <NotificationsIcon />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                        <Grid item>
                            <Tooltip title="Help">
                                <IconButton sx={{color: 'rgba(255, 255, 255, 0.7)'}} component={RouterLink} to={`/help${currentPage}`} >
                                    <HelpIcon />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                        <Grid item>
                            <IconButton color='inherit' sx={Styles.iconButtonAvatar} >
                                {
                                    (userInfo) ? (
                                    <>
                                        <Avatar {...bindTrigger(popupState)} sx={{width:40, height:40}} 
                                            src={userInfo.gravatar_url}
                                        />
                                        <Menu { ...bindMenu(popupState)} >
                                            <MenuItem key='account-logout' onClick={ popupState.close } > 
                                                <Link sx={Styles.menulink} component={RouterLink} to='/' onClick={ () => onLogout(refreshToken!) } > Logout </Link>
                                            </MenuItem>
                                        </Menu>
                                    </>
                                    ) : (
                                    <>
                                        <Avatar {...bindTrigger(popupState)} sx={{width:40, height:40}} >
                                            <AccountCircleIcon />
                                        </Avatar>
                                        <Menu { ...bindMenu(popupState)} >
                                            <MenuItem key='account-login' onClick={popupState.close} > 
                                                <Link sx={Styles.menulink} component={RouterLink} to='/login' > Login </Link>
                                            </MenuItem>
                                            <MenuItem key='account-signup' onClick={popupState.close} > 
                                                <Link sx={Styles.menulink} component={RouterLink} to='/signup' > Sign Up </Link>
                                            </MenuItem>
                                        </Menu>
                                    </>
                                    )
                                }
                            </IconButton>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
            <AppBar
                sx={Styles.secondaryBar}
                color="primary"
                position="static"
                elevation={0}
            >
                <Toolbar>
                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs>
                            <Typography color={'rgba(255, 255, 255, 0.8)'} variant="h5" component="h1">
                                {(activeView) ? activeView.title : ((userInfo) ? "Top of the Mind" : "Discover") }
                            </Typography>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
            <AppBar
                sx={Styles.secondaryBar}
                color="primary"
                position="static"
                elevation={0}
            >
                { (!activeView && userInfo) ? (
                    <Tabs value={currentTab} onChange={handleTabChange} textColor="inherit">
                        <Tab label="PERSONAL" sx={{textColor:"inherit"}} component={RouterLink} to='/' />
                        <Tab label="PROFESSIONAL" sx={{textColor:"inherit"}} component={RouterLink} to='/' />
                        <Tab label="SOCIAL" sx={{textColor:"inherit"}} component={RouterLink} to='/' />
                    </Tabs>) : (
                    <Toolbar>
                        <Typography variant="subtitle2" color={'rgba(255, 255, 255, 0.65)'}>
                            {(activeView) ? activeView.subtext : "Pensieve helps you Manage your Mental Contexts"}
                        </Typography>
                    </Toolbar>)
                }
            </AppBar>
        </Box>
    )
}

export default Header;